import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "picker", "hex", "display"]

  trigger() {
    this.pickerTarget.click()
  }

  picker_update() {
    this.pickerTarget.value = this.hexTarget.value
    this.displayTarget.style.backgroundColor = this.hexTarget.value
  }

  color_update() {
    this.hexTarget.value = this.pickerTarget.value
    this.displayTarget.style.backgroundColor = this.pickerTarget.value
  }
}
